import React from "react"
import { appTools, cn } from "lib/utils"
import { Plus } from "lucide-react"

interface ISectionTitle {
  title:string;
  extension?:any;
  location?:"module"|"remote";
  className?:string;
  children?:React.ReactNode;
}

export default function SectionTitle({ title, extension, location="module", className="", children }:ISectionTitle){
  return (
    <div className={cn("w-full absolute top-[-12px] left-[20px] pr-8 flex justify-between items-center bg-transparent", className)}>
      <span className={cn("block px-3 text-xs  bg-slate-900 uppercase")}>
        { title }
      </span>
      { extension !== undefined && (
        <div className={cn("text-xs pl-1 pr-1 bg-slate-900 uppercase")}>
          { extension.type === "plus" && (
            <Plus className="w-5 h-5 cursor-pointer stroke-1 bg-slate-700 rounded-full p-1" onClick={extension.clickFn} />
          )}

          { extension.type === "generic" && (
            <span onClick={extension.clickFn}>{ extension.text }</span>
          )}
        </div>
      )}
    </div>
  )
}